<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import SidebarLinkComp from "@/components/navbar/SidebarLinkComp.vue";
import store from "@/store/store";

const isMobile = ref(false);
let username = ref("");
let is_superuser = ref();
let is_manager = ref();
let is_engineer = ref();

// Function to check screen size and update `isMobile`
function checkIsMobile() {
  isMobile.value = window.innerWidth <= 768; // Update threshold for mobile as needed
}

const closeSidebarOnClickOutside = (event) => {
  let sidebar = document.querySelector('.main-sidebar'); // Sidebar element
  let pushmenu = document.querySelector('[data-widget="pushmenu"]'); // Toggle button

  // If clicked outside the sidebar and the sidebar are open
  if (!sidebar.contains(event.target) && !pushmenu.contains(event.target) && document.body.classList.contains('sidebar-open')) {
    pushmenu.click(); // Close the sidebar
  }
};

onMounted(() => {
  if (store.getters['profile/username']){
    username.value = store.getters['profile/username'];
  }
  checkIsMobile();
  document.addEventListener('click', closeSidebarOnClickOutside);
  // Dynamically update `isMobile` on window resize
  window.addEventListener('resize', checkIsMobile);
  is_superuser = store.getters['profile/is_superuser'];
  is_engineer = store.getters['profile/is_engineer'];
  is_manager = store.getters['profile/is_manager'];
});

// Clean up event listeners on unmount
onUnmounted(() => {
  document.removeEventListener('click', closeSidebarOnClickOutside);
  window.removeEventListener('resize', checkIsMobile);
});

</script>

<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-no-expand sidebar-dark-primary position-fixed">
    <!-- Brand Logo -->
<!--    <a class="brand-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>-->

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-4 mt-lg-0 pt-5 pt-lg-3 pb-1 mb-3 d-flex">
        <div class="image">
          <img src="/adminlte-img/user.png" class="img-circle elevation-2" alt="User Image">
        </div>
        <div class="info">
          <p class="d-block" style="color: lightgray">{{ username }}</p>
        </div>
      </div>
      <nav class="h-100 d-flex flex-column">
        <ul class="nav nav-pills nav-sidebar flex-column flex-grow-1" data-widget="treeview" role="menu" data-accordion="false">
          <sidebar-link-comp
            v-if="is_manager || is_engineer"
            :link_name="`Консультация`"
            :api_url="`/requests_from_landing`"
            :link_icon="`fa-phone-alt`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          ></sidebar-link-comp>
          <sidebar-link-comp
            :link_name="`Активные заявки`"
            :api_url="`/active_requests`"
            :link_icon="`fa-fire`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          >
          </sidebar-link-comp>
          <sidebar-link-comp
            :link_name="`Заявки на доработку`"
            :api_url="`/requests_for_revision`"
            :link_icon="`fa-stopwatch`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          >
          </sidebar-link-comp>
          <sidebar-link-comp
            :link_name="`Все заявки`"
            :api_url="`/all_requests`"
            :link_icon="`fa-tag`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          ></sidebar-link-comp>
          <sidebar-link-comp
              :link_name="`Отключение`"
              :api_url="`/disconnection_requests`"
              :link_icon="`fa-user-slash`"
              v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          >
          </sidebar-link-comp>
          <sidebar-link-comp
            :link_name="`Абоненты`"
            :api_url="`/clients`"
            :link_icon="`fa-user`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          ></sidebar-link-comp>

          <sidebar-link-comp
            v-if="is_manager || is_engineer"
            :link_name="`Стат. по заявкам`"
            :api_url="`/requests_dashboard`"
            :link_icon="`fa-chart-pie`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          ></sidebar-link-comp>
          <sidebar-link-comp
              v-if="is_manager"
            :link_name="`Стат. по монтерам`"
            :api_url="`/fitters_dashboard`"
            :link_icon="`fa-chart-bar`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          ></sidebar-link-comp>
          <sidebar-link-comp
            v-if="is_superuser"
            :link_name="`Админ`"
            :api_url="`/admin`"
            :link_icon="`fa-tools`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          >
          </sidebar-link-comp>
          <sidebar-link-comp
            :link_name="`Профиль`"
            :api_url="`/profile`"
            :link_icon="`fa-user-circle`"
            v-bind="isMobile ? { 'data-widget': 'pushmenu' } : {}"
          >
          </sidebar-link-comp>
        </ul>
      </nav>
    </div>
    <!-- /.sidebar -->
  </aside>
</template>


<style scoped>
</style>